var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "950" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              !_vm.inquiry
                ? _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            fab: "",
                            dark: "",
                            small: "",
                            color: "teal",
                          },
                          on: {
                            click: function ($event) {
                              _vm.hasAsked = false
                              _vm.confirmed = false
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [
                        _vm._v("mdi-plus"),
                      ]),
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: { icon: "", color: "green" },
                          on: {
                            click: function ($event) {
                              _vm.hasAsked = false
                              _vm.confirmed = false
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [
                        _vm._v("mdi-pencil-outline"),
                      ]),
                    ],
                    1
                  ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm._v(" "),
      _vm.isNotConfirm
        ? _c(
            "v-card",
            { staticClass: "user-inquiry-dialog pb-4" },
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(
                  _vm._s(
                    !_vm.hasAsked
                      ? "問い合わせを作成する"
                      : "問い合わせありがとうございました"
                  )
                ),
              ]),
              _vm._v(" "),
              !_vm.hasAsked
                ? _c(
                    "v-card-text",
                    [
                      _vm.invalidName
                        ? _c(
                            "p",
                            { staticClass: "text-sm-body-2 red--text mb-2" },
                            [_vm._v("名前を入力してください")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errorMessage
                        ? _c(
                            "p",
                            { staticClass: "text-sm-body-2 red--text mb-2" },
                            [_vm._v(_vm._s(_vm.errorMessage))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invalidBody
                        ? _c(
                            "p",
                            { staticClass: "text-sm-body-2 red--text mb-2" },
                            [_vm._v("内容を入力してください")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: { label: "名前", required: "" },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                      _vm._v(" "),
                      _c("Simplemde", {
                        attrs: {
                          name:
                            "question-list-" +
                            (_vm.inquiry ? _vm.inquiry.id : "new"),
                          rows: 3,
                        },
                        model: {
                          value: _vm.body,
                          callback: function ($$v) {
                            _vm.body = $$v
                          },
                          expression: "body",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  !_vm.confirmed
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "green", dark: "" },
                          on: { click: _vm.changeToConfirm },
                        },
                        [_vm._v("\n        問い合わせを投稿する\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.confirmed
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "green darken-1", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.dialog = false
                            },
                          },
                        },
                        [_vm._v("キャンセル\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "v-card",
            { staticClass: "user-inquiry-dialog pb-4" },
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(
                  _vm._s(
                    !_vm.hasAsked
                      ? "この問い合わせ内容で投稿しますか"
                      : "問い合わせありがとうございました"
                  )
                ),
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              !_vm.hasAsked
                ? _c(
                    "v-card-text",
                    [
                      _vm.invalidName
                        ? _c(
                            "p",
                            { staticClass: "text-sm-body-2 red--text mb-2" },
                            [_vm._v("名前を入力してください")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errorMessage
                        ? _c(
                            "p",
                            { staticClass: "text-sm-body-2 red--text mb-2" },
                            [_vm._v(_vm._s(_vm.errorMessage))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invalidBody
                        ? _c(
                            "p",
                            { staticClass: "text-sm-body-2 red--text mb-2" },
                            [_vm._v("内容を入力してください")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-card-title", { staticClass: "headline" }, [
                        _vm._v(_vm._s(_vm.name)),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _c("div", {
                          staticClass: "mb-4 white-space-pre-line html-body",
                          domProps: { innerHTML: _vm._s(_vm.markdownBody) },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c(
                              "v-col",
                              { staticClass: "p-0", attrs: { cols: "12" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "float-right d-flex" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "me-2",
                                        attrs: { cols: "2" },
                                      },
                                      [
                                        _vm.user && _vm.user.image
                                          ? _c("img", {
                                              staticStyle: { width: "40px" },
                                              attrs: {
                                                src: _vm.user.image.url,
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-col", [
                                      _vm.user
                                        ? _c("div", [
                                            _vm._v(_vm._s(_vm.user.name)),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "grey--text" }, [
                                        _vm._v(
                                          _vm._s(_vm.currentTime) +
                                            "に問い合わせします。"
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "inquiry-btn" },
                [
                  !_vm.hasAsked
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "green", dark: "" },
                          on: { click: _vm.createInquiry },
                        },
                        [_vm._v("\n        問い合わせを投稿する\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hasAsked
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "green darken-1", text: "" },
                          on: { click: _vm.backToForm },
                        },
                        [_vm._v("修正する\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasAsked
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "green darken-1", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.dialog = false
                            },
                          },
                        },
                        [_vm._v("OK\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }